/**
 * The Font a property of a resource names, resolved against the font files loaded so far. A pure
 * walk, so a builder reads a font without a hook, and the caller loads each path the walk read.
 */
import { recordingReads } from '../../../r3f/cacheSources';
import { resolveInlineFontResource } from './decode';
/** Resolves `ref` in `resources` through `loadedFont`. */
export function resolveFontReference(ref, { externalResources, internalResources }, loadedFont) {
    const paths = [];
    const font = resolveInlineFontResource(ref, externalResources, internalResources, recordingReads({ getCached: loadedFont }, (path) => paths.push(path)), new Set());
    return { font, paths };
}
//# sourceMappingURL=resolveFontReference.js.map